import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface StatusChangeNotificationProps {
  trackName: string;
  newStatus: string;
  success: boolean;
  onClose: () => void;
}

const StatusChangeNotification: React.FC<StatusChangeNotificationProps> = ({
  trackName,
  newStatus,
  success,
  onClose
}) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Allow fade out animation
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  return (
    <div
      className={`fixed top-4 right-4 z-50 max-w-sm bg-[var(--color-surface)] border border-[var(--color-border)] rounded-lg shadow-lg transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
      }`}
    >
      <div className="p-4 flex items-start gap-3">
        <div className="flex-shrink-0">
          {success ? (
            <CheckCircleIcon className="w-5 h-5 text-green-500" />
          ) : (
            <ExclamationTriangleIcon className="w-5 h-5 text-red-500" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-[var(--color-text)]">
            {success ? (
              <>
                <span className="font-semibold">{trackName}</span> {t('dashboard.statusChangedTo')} <span className="font-semibold">{t(`track.statusLabels.${newStatus}`, newStatus)}</span>
              </>
            ) : (
              <>
                {t('dashboard.statusUpdateFailed')} <span className="font-semibold">{trackName}</span>
              </>
            )}
          </p>
        </div>
        <button
          onClick={handleClose}
          className="flex-shrink-0 text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors"
        >
          <span className="sr-only">Close</span>
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default StatusChangeNotification;




























